import { useState } from "react";
import { apiFetch } from "../utils/api";
import { useNavigate } from "react-router-dom";

function SubmitArticle() {
  const [form, setForm] = useState({
    title: "",
    description: "",
    content: "",
    author: "",
    image: null
  });

  const navigate = useNavigate();

  const handleSubmit = async e => {
    e.preventDefault();

    const formData = new FormData();

    // 👇 Explicit fields (important)
    formData.append("title", form.title);
    formData.append("description", form.description);
    formData.append("content", form.content);
    formData.append("author", form.author);

    // 👇 Explicit image field (THIS is the key)
    if (form.image) {
      formData.append("image", form.image);
    }

    await apiFetch("/articles/submit", {
      method: "POST",
      body: formData
    });

    alert("Article submitted for review!");
    navigate("/");
  };

  return (
    <form
        className="submit-article-form"
        onSubmit={handleSubmit}
        encType="multipart/form-data"
        >
        <h1>Submit an Article</h1>

        <label>
            Title
            <input
            placeholder="Enter article title"
            value={form.title}
            onChange={e => setForm({ ...form, title: e.target.value })}
            required
            />
        </label>

        <label>
            Your Name
            <input
            placeholder="How should we credit you?"
            value={form.author}
            onChange={e => setForm({ ...form, author: e.target.value })}
            required
            />
        </label>

        <label>
            Article Contents
            <textarea
            placeholder="Text of article."
            value={form.description}
            onChange={e => setForm({ ...form, description: e.target.value })}
            required
            />
        </label>

        <label>
            Featured Image (optional)
            <input
            type="file"
            accept="image/*"
            onChange={e => setForm({ ...form, image: e.target.files[0] })}
            />
        </label>

        <div className="form-actions">
            <button type="submit" className="submit-btn">
                Submit for Review
            </button>

            <button
                type="button"
                className="cancel-btn"
                onClick={() => navigate("/")}
            >
                Cancel
            </button>
            </div>
    </form>

  );
}

export default SubmitArticle;
